module.exports = __webpack_public_path__ + "static/media/Karl Conrad Headshot_1687522394688.c215e7c6.jpeg";